import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";

export default function SubscriptionDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    saasApi.adminAnalyticsOverview().then((res) => setData(res.data));
  }, []);

  if (!data) return <p>Loading…</p>;

  const c = data.companies || {};
  return (
    <div>
      <h1>Subscription dashboard</h1>
      <div className="saas-stats">
        <div className="saas-stat"><span>Total companies</span><strong>{c.total}</strong></div>
        <div className="saas-stat"><span>Active</span><strong>{c.active}</strong></div>
        <div className="saas-stat"><span>Trialing</span><strong>{c.trialing}</strong></div>
        <div className="saas-stat"><span>Expired</span><strong>{c.expired}</strong></div>
      </div>
    </div>
  );
}
